import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";

export interface SystemLogItem {
  id: string;
  ts: string;
  level: string;
  subsystem: string;
  message: string;
  error_name: string | null;
  error_message: string | null;
  error_stack: string | null;
  context: unknown;
}

export interface SystemLogPage {
  items: SystemLogItem[];
  nextCursor: string | null;
}

export interface SystemLogFilters {
  // Exact match, unless the value ends with ":" — then prefix match against
  // the hierarchical taxonomy (e.g., "tool:" catches "tool:search_events" etc.).
  subsystem?: string;
  since?: string;
  until?: string;
  limit?: number;
}

function buildQuery(filters: SystemLogFilters, cursor?: string): string {
  const params = new URLSearchParams();
  if (filters.subsystem) params.set("subsystem", filters.subsystem);
  if (filters.since) params.set("since", filters.since);
  if (filters.until) params.set("until", filters.until);
  if (filters.limit) params.set("limit", String(filters.limit));
  if (cursor) params.set("cursor", cursor);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function useSystemLog(filters: SystemLogFilters) {
  return useInfiniteQuery<SystemLogPage>({
    queryKey: ["system-log", filters],
    initialPageParam: undefined,
    queryFn: async ({ pageParam }) =>
      apiFetch<SystemLogPage>(
        `/api/dev/system-log${buildQuery(filters, pageParam as string | undefined)}`
      ),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
